// extracted by mini-css-extract-plugin
export default {"rightSide":"adminProfile_rightSide__+FWTh"};